import { render, staticRenderFns } from "./noiseDetected.vue?vue&type=template&id=ec5e2d12&"
import script from "./noiseDetected.vue?vue&type=script&lang=js&"
export * from "./noiseDetected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports